import { getI18nFromGeneral } from '@/src/tools/tools';
import { get } from 'lodash';
import { handleError } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';

const validateName = (name) => {
  if (!name) {
    return handleError([
      getI18nFromGeneral('general.error.thisitemcannotbeempty'),
    ]);
  }
};

const validateTime = (pageSetting) => {
  const { alwaysOn, endTime, endDate, beginTime, beginDate } =
    pageSetting || {};

  if (!alwaysOn && !(endTime && endDate && beginTime && beginDate)) {
    return handleError([
      getI18nFromGeneral('general.error.thisitemcannotbeempty'),
    ]);
  }
};

const checkAll = (pageSetting) => {
  const { alwaysOn, name, endTime, endDate, beginTime, beginDate } =
    pageSetting || {};
  const nameRes = validateName(name);
  const timeRes = validateTime({
    alwaysOn,
    endTime,
    endDate,
    beginTime,
    beginDate,
  });
  return { hasError: get(nameRes, 'hasError') || get(timeRes, 'hasError') };
};
export { checkAll, validateName, validateTime };
// const validatePageSetting = (pageSetting) => {
//   const specificErr = {};
//   const { alwaysOn, name, endTime, endDate, beginTime, beginDate } =
//     pageSetting || {};

//   specificErr['nameError'] = [];
//   specificErr['timePickerError'] = [];
//   if (!name) {
//     specificErr['nameError'].push('name 不能为空');
//   }

//   if (
//     !alwaysOn &&
//     !(endTime && endDate && beginTime && beginDate) &&

//   ) {
//     specificErr['timePickerError'].push('time 不能为空');
//   }
//   return {
//     hasError: convertSpecificError(specificErr).length > 0,
//     specificError: specificErr,
//     generalError: [],
//   };
// };
